import { render, staticRenderFns } from "./ownerVillage.vue?vue&type=template&id=44fc0138&scoped=true&"
import script from "./ownerVillage.vue?vue&type=script&lang=js&"
export * from "./ownerVillage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fc0138",
  null
  
)

export default component.exports